// extracted by mini-css-extract-plugin
export var externalLink = "_aj-0";
export var internalLinkLabel = "_aj-1";